import {PrismicPreviewProvider} from 'gatsby-plugin-prismic-previews'
import React from 'react'

// Styling for the Prismic preview modals.
import 'gatsby-plugin-prismic-previews/dist/styles.css'

// Adds a shared React Context for Prismic preview sessions.
export const WrapRootElement: React.FC = ({children}) => (
    <PrismicPreviewProvider>{children}</PrismicPreviewProvider>
)
